/* eslint-disable jsx-a11y/alt-text */
import { FC } from "react";
import { BlogPostProps } from "./types";
import moment from "moment";
import { BlogCategories } from "../BlogCategories";
import Image from "next/image";
const BlogPost: FC<BlogPostProps> = ({
  title,
  slug,
  description,
  categories,
  backgroundImage,
  author,
  timeRead,
  dateAdded,
  handlePostClick,
  content,
}) => (
  <article className="flex flex-col space-y-4">
    {categories && <BlogCategories categories={categories} isPost />}

    <div className="relative">
      {backgroundImage && (
        <Image
          src={backgroundImage}
          alt="Background image"
          sizes="(max-width: 768px) 100vw, 33vw"
          width={1024}
          height={300}
          className="w-full h-[300px] object-cover rounded-lg"
          quality={80}
        />
      )}
      {author?.image && (
        <Image
          src={author?.image}
          alt="Author avatar"
          sizes="(max-width: 768px) 100vw, 33vw"
          width={64}
          height={64}
          className="w-16 h-16 rounded-full border-4 border-white absolute -bottom-8 left-4 object-cover"
          quality={80}
        />
      )}
    </div>

    <div className="pt-8">
      <h2
        className="text-2xl font-bold text-primary mb-4 cursor-pointer hover:underline"
        {...(slug && {
          onClick: () => handlePostClick(slug),
        })}
      >
        {title}
      </h2>
      <p className="text-gray-900 mb-4">{description}</p>
      <div className="flex items-center space-x-4 text-gray-500">
        {timeRead && (
          <span className="flex items-center">
            <svg
              className="w-5 h-5 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            {timeRead} read
          </span>
        )}
        {dateAdded && (
          <span>{moment(dateAdded)?.locale("ro")?.format("LL")}</span>
        )}
        <span>By {author?.name}</span>
      </div>
    </div>
  </article>
);

export default BlogPost;
